import { lazy, Suspense } from 'react';
import { Outlet, Navigate } from 'react-router-dom';

import SimpleLayout from 'src/layouts/simple';
import CompactLayout from 'src/layouts/compact';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

export const HomePage = lazy(() => import('src/pages/home'));
const McpGuidePage = lazy(() => import('src/pages/mcp-guide'));
const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const FacebookConnectPage = lazy(() => import('src/pages/facebook-connect'));
const PoliticaPrivacidadePage = lazy(() => import('src/pages/politica-privacidade'));
const TermosDeUsoPage = lazy(() => import('src/pages/termos-de-uso'));

const GiftbackPublicPage = lazy(() => import('src/pages/giftback-public-page'));
const LoyaltyPublicPage = lazy(() => import('src/pages/loyalty-public-page'));
const PublicAppointmentPage = lazy(() => import('src/pages/public-appointment'));
const PublicAppointmentManagePage = lazy(() => import('src/pages/public-appointment-manage'));
// const FaqsPage = lazy(() => import('src/pages/faqs'));
// const AboutPage = lazy(() => import('src/pages/about-us'));
// const ContactPage = lazy(() => import('src/pages/contact-us'));
// const PricingPage = lazy(() => import('src/pages/pricing'));
// const PaymentPage = lazy(() => import('src/pages/payment'));
// const ComingSoonPage = lazy(() => import('src/pages/coming-soon'));
// const MaintenancePage = lazy(() => import('src/pages/maintenance'));
// PRODUCT
// const ProductListPage = lazy(() => import('src/pages/product/list'));
// const ProductDetailsPage = lazy(() => import('src/pages/product/details'));
// const ProductCheckoutPage = lazy(() => import('src/pages/product/checkout'));
// BLOG
// const PostListPage = lazy(() => import('src/pages/post/list'));
// const PostDetailsPage = lazy(() => import('src/pages/post/details'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    path: 'preview',
    element: <Navigate to="/agendar/espaco-izabelle-christofari/preview" replace />,
  },
  {
    path: 'izabelle',
    element: <Navigate to="/agendar/espaco-izabelle-christofari/preview" replace />,
  },
  {
    path: 'agendar/:slug/preview',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicAppointmentPage />
      </Suspense>
    ),
  },
  {
    path: 'agendar/:slug',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicAppointmentPage />
      </Suspense>
    ),
  },
  {
    path: 'agendar/:slug/gerenciar',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <PublicAppointmentManagePage />
      </Suspense>
    ),
  },
  // {
  //   element: (
  //     <MainLayout>
  //       <Suspense fallback={<SplashScreen />}>
  //         <Outlet />
  //       </Suspense>
  //     </MainLayout>
  //   ),
  //   children: [
  //     { path: 'about-us', element: <AboutPage /> },
  //     { path: 'contact-us', element: <ContactPage /> },
  //     { path: 'faqs', element: <FaqsPage /> },
  //     {
  //       path: 'product',
  //       children: [
  //         { element: <ProductListPage />, index: true },
  //         { path: 'list', element: <ProductListPage /> },
  //         { path: ':id', element: <ProductDetailsPage /> },
  //         { path: 'checkout', element: <ProductCheckoutPage /> },
  //       ],
  //     },
  //     {
  //       path: 'post',
  //       children: [
  //         { element: <PostListPage />, index: true },
  //         { path: 'list', element: <PostListPage /> },
  //         { path: ':title', element: <PostDetailsPage /> },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   element: (
  //     <SimpleLayout>
  //       <Suspense fallback={<SplashScreen />}>
  //         <Outlet />
  //       </Suspense>
  //     </SimpleLayout>
  //   ),
  //   children: [
  //     { path: 'pricing', element: <PricingPage /> },
  //     { path: 'payment', element: <PaymentPage /> },
  //   ],
  // },
  {
    element: (
      <SimpleLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </SimpleLayout>
    ),
    children: [
      { path: 'conectar-ia', element: <McpGuidePage /> },
      { path: 'facebook-connect', element: <FacebookConnectPage /> },
      { path: 'politica-privacidade', element: <PoliticaPrivacidadePage /> },
      { path: 'termos-de-uso', element: <TermosDeUsoPage /> },
    ],
  },
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      // { path: 'coming-soon', element: <ComingSoonPage /> },
      // { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
  {
    element: (
      <Suspense fallback={<SplashScreen />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      { path: '/', element: <HomePage /> },
      { path: ':slug/giftback', element: <GiftbackPublicPage /> },
      { path: ':slug/fidelidade', element: <LoyaltyPublicPage /> },
    ],
  },
];
